import { TechProblemsIcon } from 'src/components/layout/icons';

export default function NoDataTransformationAccess() {
  return (
    <section className="has-text-centered pt-6">
      <div className="has-text-centered mb-5">
        <TechProblemsIcon />
      </div>
      <h2 className="title is-1 has-text-grey mb-5">Oops!</h2>
      <p className="is-size-2 has-text-grey mb-5">
        There is currently no content available to you within Data Transformation based on your assigned permissions. If
        you believe you should have access, please contact the Product Support team for assistance.
      </p>
    </section>
  );
}
